/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Card } from '@blueprintjs/core';
import { DatasetSelector } from '/components/selectors/datasetSelector';
import { ExplorerLayoutManager } from '../explorerLayoutManager';
import { TimelineWrapper } from '/views/timeline/timelineWrapper';
import { ViewSettings } from '/views/viewSettings';
import { Filters } from '/views/filters';
import { Search } from '/views/search';
import { FilterHub } from '/views/filterHub';
import { Colors } from 'styles/variables';
import { Screen } from '/views/screen';

/**
 * Explorer specific instance of a Workspace.
 *
 * @returns {null|*}
 * @constructor
 */
export function RecordsExplorer({ isReady, dilName = null }) {
	return (
		<Screen isReady={isReady} dilName={dilName}>
			<div css={explorerStyle}>
				<Card css={tightCard}>
					<DatasetSelector initialValue={dilName} />
					<Filters />
				</Card>

				<Search />

				<div css={panel}>
					<Card css={dataExplorer}>
						<ViewSettings />
					</Card>
					<Card css={facets}>
						<FilterHub />
					</Card>
				</div>

				<Card css={timeline}>
					<TimelineWrapper />
				</Card>

				<div css={layout}>
					<ExplorerLayoutManager />
				</div>
			</div>
		</Screen>
	);
}

// TODO: this is in the wrong place
const explorerStyle = css`
	flex: 1 1;
	height: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr 400px;
	grid-template-rows: 30px 150px 1fr;
	grid-gap: 6px;
	padding: 8px;
	background-color: ${Colors.LIGHT_GRAY5};
	overflow: hidden;
`;

const cards = css`
	display: flex;
	align-items: center;
`;

const tightCard = css`
	${cards};
	padding: 0;
	overflow: hidden;
`;

const facets = css`
	${tightCard};
	flex: 1;
`;

const panel = css`
	grid-row: 3 span;
	display: flex;
	flex-direction: column;
`;

const timeline = css`
	${tightCard};
	grid-column: 1 / 3;
`;

const layout = css`
	${tightCard};
	grid-column: 1 / 3;
`;

const dataExplorer = css`
	width: 100%;
	border-bottom: 1px solid lightgray;
	padding: 0;
	margin-bottom: 6px;
`;
